import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzInputNumberModule } from "ng-zorro-antd/input-number";
import { CustomerRiceInvoiceFormComponent } from "./customer-rice-invoice-form.component";

@NgModule({
  declarations: [CustomerRiceInvoiceFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    NzFormModule,
    NzInputModule,
    NzInputNumberModule,
    NzDatePickerModule,
    NzButtonModule,
  ],
  exports: [CustomerRiceInvoiceFormComponent],
})
export class CustomerRiceInvoiceFormModule {}
